import * as React from "react"
const SvgSearch = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10.5 17.857q-2.725 0-4.612-1.887Q4 14.081 4 11.357t1.888-4.612T10.5 4.857t4.613 1.888Q16.999 8.632 17 11.357a6.1 6.1 0 0 1-1.3 3.8l3.6 3.6a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-3.6-3.6a6.1 6.1 0 0 1-3.8 1.3m0-2q1.875 0 3.188-1.312Q15 13.232 15 11.357T13.687 8.17Q12.375 6.857 10.5 6.857T7.312 8.17C5.999 9.483 6 10.107 6 11.357q0 1.875 1.313 3.188c1.313 1.313 1.937 1.312 3.187 1.312" />
  </svg>
)
export default SvgSearch
